import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { formatString } from "@/core/utils/helpers";
import { AddVisaRequestDTO } from "../dto/addVisaRequest.dto";
import { VISA_VERIFICATION_API_PATH } from "../constants";
import download from "downloadjs";

class VisaVerificationService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public addVisaRequest(
    payload: AddVisaRequestDTO,
    organizationId: string,
  ): Promise<ICoreResponse<any>> {
    return this.restClient.post(
      formatString(VISA_VERIFICATION_API_PATH.ADD_VISA_REQUEST, organizationId),
      payload,
    );
  }
  public getVisaRequests(organizationId: string): Promise<ICoreResponse<any>> {
    return this.restClient.get(
      formatString(
        VISA_VERIFICATION_API_PATH.GET_VISA_REQUESTS,
        organizationId,
      ),
    );
  }
  public async downloadVisaPDF(id: string, watermarkPosition: string) {
    try {
      const url = formatString(
        VISA_VERIFICATION_API_PATH.DOWNLOAD_VERIFIED_VISA,
        id,
      );
      const params = {
        ...(watermarkPosition && { watermark_position: watermarkPosition }),
      };
      const response: ICoreResponse = await this.restClient.get(url, params, {
        responseType: "blob",
      });
      download(response.data, "Visa Ok To Board.pdf");
    } catch (err) {
      console.error("Error in downloadVisaPDF:", err);
    }
  }

  public async openUrlDownloadVisaPDF(name: string, id: string) {
    const url = formatString(
      VISA_VERIFICATION_API_PATH.OPEN_DOWNLOAD_VERIFIED_VISA,
      name,
      id,
    );
    return this.restClient.get(
      url,
      {},
      {
        responseType: "blob",
      },
    );
  }
}

export default VisaVerificationService;
